import { observable } from "mobx";
import http from 'libs/http';

class Store {
  @observable records = [];
  @observable type = [];
  @observable record = {};
  @observable isFetching = false;
  @observable formVisible = false;

  @observable f_name;
  @observable f_type;

  fetchRecords = () => {
    this.isFetching = true;
    http.get('/api/student/class/')
      .then(({st_class, st_class_type}) => {
        this.type = st_class_type;
        this.records = st_class;
      })
      .finally(() => this.isFetching = false)
  };

  showForm = (info = {}) => {
    this.formVisible = true;
    this.record = info
  }
}

export default new Store()
